import React, { Component, useEffect, useState } from 'react';
import Zagolovok from '../Components/Zagolovok';
//import Price from '../Components/Price';
import Slider from '../Components/Slider';
import Bazaprice from '../Components/Bazaprice';
import Krovlyaprice from '../Components/Krovlyaprice';
import Mainob from '../Components/Mainob';

const Home = () => {
  const [item, setItem] = useState([]);
  useEffect(() => {
    document.title = 'Конопатка, отделка, покраска сруба';}
  );
}

const divStyle = {
  paddingTop: '40px',
};

export default class 
 extends Component {
  render() {
    return (
      <div>
        
        <Zagolovok />
        <Bazaprice />
        <Krovlyaprice />
        <Mainob />
        <h1  style={divStyle}>Наши работы</h1>
        <Slider />
        
      </div>
    )
  }
}
